import { useEffect, useState } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import React from 'react'
import hesham from '../../assets/images/hesham.png'
import Delayed from '../Delayed'
import { FaCopy } from 'react-icons/fa'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const notify = () => toast('Copied')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
  }, [])

  return (
    <>
      <ToastContainer
        className="toast-container"
        position="bottom-center"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <div className="about-container">
        <div className="text-zone">
          <h1 className="about-h1">ABOUT</h1>
          <Delayed>
            {' '}
            <hr
              style={{
                color: '#323232',
                backgroundColor: '#323232',
                height: 0.08,
                borderColor: '#323232',
                opacity: 0.3,
                border: '1px solid rgba(0, 0, 0, 0.3)',
                marginTop: '23px',
                transition: ' opacity 2s',
              }}
            />
          </Delayed>
          <div className="h2-container">
            <h2>
              I am a self-taught UX generalist who hold a bachelor degree in
              software engineering and professional experience in both software
              development and motion design. I am data-oriented, and enjoy
              creating dynamic and fresh prototypes.
            </h2>
            <h2>
              I am interested in the user experience for new and emerging
              technologies, and always eager to learn something new.
            </h2>
            <h2>
              Shoot a line in English, Arabic or French at:
              <span
                className="email"
                onClick={() =>
                  (window.location = 'mailto:heshamnasser@protonmail.com')
                }
              >
                {' '}
                heshamnasser@protonmail.com
              </span>
              <button
                className="copy"
                onClick={() => {
                  navigator.clipboard.writeText('heshamnasser@protonmail.com')
                  notify()
                }}
              >
                <FaCopy />
              </button>
            </h2>
          </div>
        </div>
        <div>
          <img src={hesham} alt="portfolio" className="hesham-image" />
        </div>
      </div>
    </>
  )
}

export default About
